import React from 'react';

import { Container, Content, IconContainer, Label, Value } from './styled';

interface FinancialCardProps {
  icon: React.JSX.Element;
  label: string;
  value?: string;
}

const FinancialCard = ({ icon, label, value }: FinancialCardProps) => {
  return (
    <Container>
      <IconContainer>{icon}</IconContainer>

      <Content>
        <Label>{label}</Label>

        <Value>{value}</Value>
      </Content>
    </Container>
  );
};

export default FinancialCard;
